import { PanelLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

import HulahoopLogo from "@/assets/hulahoop-logo-pos.svg";
import HulahoopLogoMini from "@/assets/hulahoop-logo-mini-pos.svg";
import { ROUTES } from "@/app/routes";
import { useEditorPanelStore } from "@/stores/useEditorPanelStore";
import { cn } from "@/utils";

export const EditorSidebarHeader = () => {
	const navigate = useNavigate();
	const isSidebarOpen = useEditorPanelStore((state) => state.isSidebarOpen);
	const toggleSidebar = useEditorPanelStore((state) => state.toggleSidebar);

	const handleLogoClick = () => {
		navigate(ROUTES.ORGANIZATION.TEMPLATES);
	};

	return (
		<div
			className={cn(
				"flex items-center justify-between h-14 flex-shrink-0 bg-[var(--sidebar-default-bg)] border-r border-[var(--sidebar-default-border)] px-4 transition-[width] duration-200 ease-out",
				isSidebarOpen ? "" : "border-b",
				isSidebarOpen ? "w-sidebar-expanded" : "w-28",
			)}
		>
			<button
				type="button"
				onClick={handleLogoClick}
				aria-label="Go to templates"
				className="flex flex-shrink-0 items-center justify-center rounded-md transition-opacity duration-200 hover:opacity-80"
			>
				<img
					src={isSidebarOpen ? HulahoopLogo : HulahoopLogoMini}
					alt="Hulahoop"
					className={isSidebarOpen ? "h-10" : "h-8"}
				/>
			</button>
			<button
				type="button"
				onClick={toggleSidebar}
				aria-label={
					isSidebarOpen ? "Close navigation sidebar" : "Open navigation sidebar"
				}
				className="p-1.5 flex-shrink-0 rounded-md hover:bg-hover-secondary hover:shadow-sm hover:scale-102 transition-all duration-200"
			>
				<PanelLeft size={18} className="text-text-secondary" />
			</button>
		</div>
	);
};
